import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { patientobj, FluoroscopeImage } from 'src/app/PatientChart/OR-Note/encounter-note/orfluoroscope-images/orfluoroscope-images.component';
import { configuration } from 'src/environments/environment';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';
import { IDocument } from 'src/app/models/IDocument';

@Injectable({
  providedIn: 'root'
})
export class FluoroscopeImageService {

  constructor(private http: HttpClient) { }

  SaveFluoroscopeImages(chkImageList: FluoroscopeImage[]): Observable<any> {
    // chkImageList.map(x=> {x.imageData=null});
    //  chkImageList.map(x=> {
    //     const imgarray=x.imageData;
    //     x.imageData=[];
    //     Object.keys(imgarray).forEach((key) =>{
    //       x.imageData.push(imgarray[key]);        
    //     });
    //  });

    // const byteArray = [];

    return this.http.post<any>(`${configuration.fluoroApiUrl + 'FluoroCache/FluoroscopeImage'}?userId=${sessionStorage.getItem("userId")}`, chkImageList, {
      headers: new HttpHeaders({ 'content-Type': 'application/json', 'Access-Control-Allow-Origin': '*', 'No-Auth': 'True' })
    });
  }

  uploadmultiImages(uploadlist: FluoroscopeImage[]): Observable<any> {
    return this.http.post<any>(`${configuration.fluoroApiUrl + 'FluoroCache/CaptureFluoro'}?userId=${sessionStorage.getItem("userId")}`, uploadlist, {
      headers: new HttpHeaders({ 'content-Type': 'application/json', 'Access-Control-Allow-Origin': '*', 'No-Auth': 'True' })
    });
  }

  GetFluoreScopeImages(): Observable<FluoroscopeImage[]> {
    const PostData = {
      encId: sessionStorage.getItem("encounterid"),
      locationId: sessionStorage.getItem("LocationId"),
      userId: sessionStorage.getItem("userId"),
      PatId: sessionStorage.getItem("patientId"),
      facilityId: sessionStorage.getItem("FacilityId")
    };
    return this.http.post<FluoroscopeImage[]>(`${configuration.apiUrl + 'Document/GetFluoroscopeImage'}`, PostData);
    // var encounterId = sessionStorage.getItem("encounterid");
    // return this.http.get<FluoroscopeImage[]>(`${configuration.apiUrl + 'Document/FluoroscopeImage'}?encId=${encounterId}&&locationId=${Number(sessionStorage.getItem("LocationId"))}&&userId=${sessionStorage.getItem("userId")}&&PatId=${sessionStorage.getItem("patientId")}`);
  }

  // deleteUploadImages(fciIdObj1: FluoroscopeImage): Observable<string> {
  //   return this.http.post<string>(`${configuration.fluoroApiUrl + 'FluoroCache/deluploadImage'}`, fciIdObj1, {
  //     headers: new HttpHeaders({ 'content-Type': 'application/json' , 'Access-Control-Allow-Origin': '*', 'No-Auth': 'True'})
  //   });
  // }
  multideleteUploadImages(multidellist: string[], encounterId: string, patId: number, locId: number): Observable<string> {
    //var encounterId = encounterId//sessionStorage.getItem("encounterid");
    return this.http.post<string>(`${configuration.fluoroApiUrl + 'FluoroCache/MultideluploadImage'}?encId=${encounterId}&&locationId=${locId}&&userId=${sessionStorage.getItem("userId")}&&PatId=${patId}&&facilityId=${sessionStorage.getItem("FacilityId")}`, multidellist, {
      headers: new HttpHeaders({ 'content-Type': 'application/json', 'Access-Control-Allow-Origin': '*', 'No-Auth': 'True' })
    });
  }


  SavetoFluoroChart(seletedImagesList: any, FluoroReportCatName: string, FluoroReportSubcatName: string): Observable<IDocument> {

    var encounterId = sessionStorage.getItem("encounterid");
    return this.http.post<IDocument>(`${configuration.fluoroApiUrl + 'FluoroCache/SavetoFluoroReport'}?encId=${encounterId}&&locationId=${Number(sessionStorage.getItem("LocationId"))}&&userId=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}&&PatId=${sessionStorage.getItem("patientId")}&&catname=${FluoroReportCatName}&&subcat=${FluoroReportSubcatName}&&facid=${Number(sessionStorage.getItem("FacilityId"))}`, seletedImagesList, {
      headers: new HttpHeaders({ 'content-Type': 'application/json', 'Access-Control-Allow-Origin': '*', 'No-Auth': 'True' })
    });

  }

  RenameUploadImage(newFileLabelName: string, oldFileLabelName: string, IsDbRecord: boolean, fileExt: string): Observable<string> {
    const PostData = {
      encId: sessionStorage.getItem("encounterid"),
      locationId: sessionStorage.getItem("LocationId"),
      userId: sessionStorage.getItem("userId"),
      PatId: sessionStorage.getItem("patientId"),
      newFileName: newFileLabelName,
      oldFileName: oldFileLabelName,
      IsDbRecord: IsDbRecord,
      facilityId: sessionStorage.getItem("FacilityId"),
      fileExt: fileExt
    };

    return this.http.post<string>(`${configuration.fluoroApiUrl + 'FluoroCache/FileRename'}`, PostData, {
      headers: new HttpHeaders({ 'Access-Control-Allow-Origin': '*', 'No-Auth': 'True' })
    });

    // return this.http.get<string>(`${configuration.fluoroApiUrl + 'FluoroCache/FileRename'}?encId=${encounterId}&&locationId=${Number(sessionStorage.getItem("LocationId"))}&&userId=${sessionStorage.getItem("userId")}&&PatId=${sessionStorage.getItem("patientId")}&&newFileName=${newFileLabelName}&&oldFileName=${oldFileLabelName}&&isDbRecord=${IsDbRecord}`,  {
    //   headers: new HttpHeaders({ 'Access-Control-Allow-Origin': '*', 'No-Auth': 'True'})
    // });
  }
  // deleteFluoroscopeImage(fciIdObj: FluoroscopeImage): Observable<string> {
  //   return this.http.post<string>(`${configuration.apiUrl + 'Document/DelFluoroscopeImage'}`, fciIdObj, {
  //     headers: new HttpHeaders({ 'content-Type': 'application/json' })
  //   });
  // }

  // deleteMultipleFluoroscopeImages(delImageList: FluoroscopeImage[]): Observable<any> {
  //   return this.http.post<any>(`${configuration.apiUrl + 'Document/DelFluoroscopeImage'}?userId=${sessionStorage.getItem("userId")}`, delImageList, {
  //     headers: new HttpHeaders({ 'content-Type': 'application/json' })
  //   });
  // }

  GetPatDetails(): Observable<patientobj> {
    var encounterId = sessionStorage.getItem("encounterid");
    return this.http.get<patientobj>(`${configuration.apiUrl + 'Document/PatDetails'}?encId=${encounterId}&&userId=${sessionStorage.getItem("userId")}`);
  }

  GetPatDetailsByEncId(endId: string): Observable<patientobj> {
    var encounterId = endId //sessionStorage.getItem("encounterid");
    return this.http.get<patientobj>(`${configuration.apiUrl + 'Document/PatDetails'}?encId=${encounterId}&&userId=${sessionStorage.getItem("userId")}`);
  }

  GetDocumentFluoreScopeImages(): Observable<FluoroscopeImage[]> {
    const DocFluoro_PenRequest = {
      encId: sessionStorage.getItem("encounterid"),
      locationId: Number(sessionStorage.getItem("LocationId")),
      userId: encodeURIComponent(sessionStorage.getItem("userId")).toString(),
      PatId: sessionStorage.getItem("patientId")
    }

    return this.http.post<FluoroscopeImage[]>(`${configuration.apiUrl + 'Document/DocFluoroscopeImage'}`, DocFluoro_PenRequest, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }

  UploadFluoroDocument(docObject: IDocument, fluoroDocUrl: string): Observable<string> {
    const postedData = {
      inputData: JSON.stringify(docObject),
      signature: encodeURIComponent(fluoroDocUrl)
    }
    return this.http.post<string>(`${configuration.apiUrl + 'Document/UploadFluoroDoc'}`, postedData, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }
}
